import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'


const Layout = ()=> import('@/components/main/Layout.vue')
const _404 = ()=> import('@/components/404.vue')
const Login = () => import('@/views/Login.vue')
const Index = () => import('@/views/index.vue')
const Ajsl = ()=> import('@/components/main/fzba/ajsl.vue')
const Ajlb = ()=> import('@/components/main/fzba/ajlb.vue')
const Baxq = ()=> import('@/components/main/fzba/baxq.vue')
const Baxq2 = ()=> import('@/components/main/fzba/baxq2.vue')
const Jcfx = ()=> import('@/components/main/fzba/jcfx.vue')
const Dzdak = ()=> import('@/components/main/dzda/dzdak.vue')
const Daxq = ()=> import('@/components/main/dzda/daxq.vue')
const DaxqYz = ()=> import('@/components/main/dzda/daxqYz.vue')

const Ajtb = ()=> import('@/components/main/dzda/ajtb.vue')
const Xcws = ()=> import('@/components/main/xcws/xcws.vue')
const Xdr = ()=> import('@/components/main/xdr/xdr.vue')
const Wdxdr = ()=> import('@/components/main/xdr/wdxdr.vue')
const Sfqx = ()=> import('@/components/main/set/sfqx.vue')
const Xtwh = ()=> import('@/components/main/set/xtwh.vue')
const Mmxg = ()=> import('@/components/main/set/mmxg.vue')
const Pdf = ()=> import('@/components/main/wslb/pdf.vue')
const Pdf2 = ()=> import('@/components/main/znba/wslb/pdf.vue')
const Szpc = ()=> import('@/components/main/ahpc/szpc.vue')
const Znwd = ()=> import('@/components/main/ahpc/znwd.vue')
const Pcaj = ()=> import('@/components/main/ahpc/pcaj.vue')
const Ajpc = ()=> import('@/components/main/ahpc/ajpc.vue')
const Ajsc = ()=> import('@/components/main/ahpc/ajsc.vue')
const Pczb = ()=> import('@/components/main/pczb.vue')

const Jcjg = ()=> import('@/components/main/jcjg.vue')
const Yhgl = ()=> import('@/components/main/set/yhgl.vue')
const Gzbm = ()=> import('@/components/main/set/gzbm.vue')

const Fbrw = ()=> import('@/components/main/task/fbrw.vue')
const Rwzx = ()=> import('@/components/main/task/rwzx.vue')
const Rwlb = ()=> import('@/components/main/task/rwlb.vue')

const Rwsh = ()=> import('@/components/main/task/rwsh.vue')
const Znsl = ()=> import('@/components/main/znba/znsl.vue')
const Znlb = ()=> import('@/components/main/znba/znlb.vue')
const Znxq = ()=> import('@/components/main/znba/znxq2.vue')




Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    redirect: '/index',
  },
  {
    path:'/login',
    name:'login',
    component:Login,
    meta:{requiresAuth: true, name: '登录页',title: '登录页'}
  },
  {
    path:'/pdf',
    name:'/pdf',
    component:Pdf,
    meta:{requiresAuth: true, name: '文书',title: '文书'}
  },
  {
    path:'/pdf2',
    name:'/pdf2',
    component:Pdf2,
    meta:{requiresAuth: true, name: '智能文书',title: '智能文书'}
  },
  {
    path:'/',
    name:'/',
    component:Layout,
    children:[
      {
        path:'/index',
        name:'/index',
        component:Index,
        meta:{requiresAuth: true, name: '首页',title: '首页'}
      },
      {
        path:'/ajsl',
        name:'/ajsl',
        component:Ajsl,
        meta:{requiresAuth: true, name: '一般程序处罚案件受理',title: '一般程序处罚案件受理'}
      },
      {
        path:'/ajlb',
        name:'/ajlb',
        component:Ajlb,
        meta:{requiresAuth: true, name: '一般程序处罚案件列表',title: '一般程序处罚案件列表'}
      },
      {
        path:'/baxq',
        name:'/baxq',
        component:Baxq,
        meta:{requiresAuth: true, name: '案件详情',title: '案件详情'}
      },
      {
        path:'/baxq2',
        name:'/baxq2',
        component:Baxq2,
        meta:{requiresAuth: true, name: '案件详情',title: '案件详情'}
      },
      {
        path:'/jcfx',
        name:'/jcfx',
        component:Jcfx,
        meta:{requiresAuth: true, name: '决策分析',title: '决策分析'}
      },
      {
        path:'/dzdak',
        name:'/dzdak',
        component:Dzdak,
        meta:{requiresAuth: true, name: '电子档案库',title: '电子档案库'},
        props: true // 启用 params
      },
      {
        path:'/daxq',
        name:'/daxq',
        component:Daxq,
        meta:{requiresAuth: true, name: '电子档案详情',title: '电子档案详情'},
        props: true // 启用 params
      },
      {
        path:'/daxqYz',
        name:'/daxqYz',
        component:DaxqYz,
        meta:{requiresAuth: true, name: '电子档案详情',title: '电子档案详情'},
        props: true // 启用 params
      },
      {
        path:'/ajtb',
        name:'/ajtb',
        component:Ajtb,
        meta:{requiresAuth: true, name: '省案卷同步',title: '省案卷同步'}
      },
      {
        path:'/xcws',
        name:'/xcws',
        component:Xcws,
        meta:{requiresAuth: true, name: '现场执法文书',title: '现场执法文书'}
      },
      {
        path:'/xdr',
        name:'/xdr',
        component:Xdr,
        meta:{requiresAuth: true, name: '被监管对象管理',title: '被监管对象管理'}
      },
      {
        path:'/wdxdr',
        name:'/wdxdr',
        component:Wdxdr,
        meta:{requiresAuth: true, name: '无证库',title: '无证库'}
      },
      {
        path:'/yhgl',
        name:'yhgl',
        component:Yhgl,
        meta:{requiresAuth: true, name: '用户管理',title: '用户管理'}
      },
      {
        path:'/gzbm',
        name:'gzbm',
        component:Gzbm,
        meta:{requiresAuth: true, name: '工作部门',title: '工作部门'}
      },
      {
        path:'/sfqx',
        name:'/sfqx',
        component:Sfqx,
        meta:{requiresAuth: true, name: '身份权限维护',title: '身份权限维护'}
      },
      {
        path:'/xtwh',
        name:'/xtwh',
        component:Xtwh,
        meta:{requiresAuth: true, name: '系统信息维护',title: '系统信息维护'}
      },
      {
        path:'/mmxg',
        name:'/mmxg',
        component:Mmxg,
        meta:{requiresAuth: true, name: '密码修改',title: '密码修改'}
      },
      {
        path:'/szpc',
        name:'/szpc',
        component:Szpc,
        meta:{requiresAuth: true, name: '事中评查解析',title: '事中评查解析'}
      },
      {
        path:'/znwd',
        name:'/znwd',
        component:Znwd,
        meta:{requiresAuth: true, name: '智能问答',title: '智能问答'}
      },
      {
        path:'/pcaj',
        name:'/pcaj',
        component:Pcaj,
        meta:{requiresAuth: true, name: '卷宗上传',title: '卷宗上传'}
      },
      {
        path:'/ajpc',
        name:'/ajpc',
        component:Ajpc,
        meta:{requiresAuth: true, name: '案件评查',title: '案件评查1'}
      },
      {
        path:'/ajsc',
        name:'/ajsc',
        component:Ajsc,
        meta:{requiresAuth: true, name: '案卷上传列表',title: '案卷上传列'}
      },
      {
        path:'/pczb',
        name:'/pczb',
        component:Pczb,
        meta:{requiresAuth: true, name: '评查指标',title: '评查指标'}
      },
      {
        path:'/jcjg',
        name:'jcjg',
        component:Jcjg,
        meta:{requiresAuth: true, name: '机构管理',title: '机构管理'}
      },
      {
        path:'/fbrw',
        name:'fbrw',
        component:Fbrw,
        meta:{requiresAuth: true, name: '发布任务',title: '发布任务'}
      },
      {
        path:'/rwzx',
        name:'rwzx',
        component:Rwzx,
        meta:{requiresAuth: true, name: '任务管理',title: '任务管理'}
      },
      {
        path:'/rwlb',
        name:'rwlb',
        component:Rwlb,
        meta:{requiresAuth: true, name: '任务列表',title: '任务列表'}
      },
      {
        path:'/rwsh',
        name:'rwsh',
        component:Rwsh,
        meta:{requiresAuth: true, name: '审核管理',title: '审核管理'}
      },

      {
        path:'/znsl',
        name:'/znsl',
        component:Znsl,
        meta:{requiresAuth: true, name: '一般程序辅助办案受理',title: '一般程序辅助办案受理'}
      },
      {
        path:'/znlb',
        name:'/znlb',
        component:Znlb,
        meta:{requiresAuth: true, name: '一般程序辅助办案列表',title: '一般程序辅助办案列表'}
      },
      {
        path:'/znxq',
        name:'/znxq',
        component:Znxq,
        meta:{requiresAuth: true, name: '一般程序辅助办案详情',title: '一般程序辅助办案详情'}
      },
    ]},
  {
    path: '/404',
    name:'404',
    component: _404,
    meta: {requiresAuth: true, name: '404',title:'404'}//路由元信息
  },
]

const router = new VueRouter({
  routes
})

// // 全局路由守卫
router.beforeEach((to, from, next) => {
  if(to.path === '/login'){
    next()
  }else{
    // to: Route: 即将要进入的目标 路由对象
    // from: Route: 当前导航正要离开的路由
    // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
    const nextRoute = ['/index','/ajsl','/ajlb','/baxq','/baxq2','/jcfx','/dzdak','/daxq','/ajtb','/xcws','/xdr','/wdxdr','/sfqx','/xtwh','/mmxg','/pdf','/pdf2','/szpc','/pcaj','/ajpc','/pczb','/jcjg','/yhgl','/gzbm'];
    

    let isLogin = JSON.parse(sessionStorage.getItem('userdata'))  // 是否登录
    // 未登录状态；当路由到nextRoute指定页时，跳转至login
    if (nextRoute.indexOf(to.name) >= 0) {  
      if (isLogin == null || isLogin == '') {
        router.push({ path: '/login' })
        return
      }else{
        next()
        // console.log(store.getters.userdata)
        if(!store.state.userdata){
          store.commit('SET_USERDATA',sessionStorage.getItem('userdata'))
        }
      }
    }
  }
  // 已登录状态；当路由到login时，跳转至home 
  // if (to.name === 'login') {
  //   if (isLogin) {
  //     router.push({ name: 'zhjg' });
  //   }
  // }
  next();
});
// 导航守卫：全局前置守卫
// router.beforeEach((to,from,next)=>{
  //to 将要访问的路径
  //form 代表从哪个路径跳转而来
  //next 是一个函数，表示放行
//   if(!store.getters.userdata){
//     store.commit('SET_USERDATA',sessionStorage.getItem('userdata'))
//   }
//   if(to.matched.some(record => record.meta.requiresAuth)){
//     if(isLogin()){
//         next({
//           path:'/login'
//         })
//         return
//     }else{
//       next()
//     }
//   }
//   next()
// })

// // 导航守卫：全局后置钩子
// router.afterEach((to)=>{
//   if(to.meta.requiresAuth){
//     AddTag(to)
//     let userdata = store.getters.userdata
//     if (!userdata.id){
//       let userdataTemp = JSON.parse(sessionStorage.getItem('userdata'))
//       store.commit('SET_USERDATA', userdataTemp)
//     }
//   }
// })

// function AddTag(to) {
//   let tag = store.getters.tag
//   if (tag && !tag.length){
//     let tagdata = sessionStorage.getItem('tag')
//     tag = tagdata ? JSON.parse(tagdata) : []// 页面刷新Vuex里的数据丢失，从sessionStorage取tag数据
//   }
//   let tagArr = JSON.parse(JSON.stringify(tag))
//   tagArr = tagArr ? tagArr : []
//   tagArr.map(item=> item.effect = 'light')
//   if(tag && tag.length && tag.some(item => item.fullPath === to.fullPath)){
//     tagArr.map(item=>{
//       if(item.fullPath === to.fullPath){
//         item.effect = 'dark'
//       }
//     })
//   }else{
//     if(to.fullPath == 'index' || to.fullPath == '/index'){
//       return
//     }else{
//       tagArr.push({
//         fullPath: `${to.fullPath == 'index' ? '/index' : to.fullPath }`,
//         name: to.meta.name,
//         effect: 'dark'
//       })
//     }
//   }
//   store.commit('SET_TAG',tagArr)
// }

// function isLogin() {
//   let userdata = sessionStorage.getItem('userdata')
//   if(userdata){
//       let {id,time} = JSON.parse(userdata)
//       let time1 = new Date().getTime()
//       return (id ? (time1 < time ? false:true) : true)
//   }
//   return true
// }

export default router
